import { Component, Input, Output, EventEmitter, OnInit } from '@angular/core';
import { Comment } from '../comment';
import { CommentType } from '../commentType';
import { CommentsService } from '../comments.service';

@Component({
	selector: 'app-comments',
	templateUrl: './comments.component.html',
	styleUrls: ['./comments.component.css'],
	providers: [
		CommentsService
	],
})
export class CommentsComponent {

	ngOnInit() {

		if ( ! this.numOfComments ) {
			this.numOfComments = this.comments.length;
		}

		this.type = 0; // we want the first option of commentTypes to be the disabled "select type".

	}

	commentTypes: CommentType[] = [
		{ id: 14, name: 'Telefon'},
		{ id: 13, name: 'E-post'},
		{ id: 15, name: 'Møte'},
		{ id: 5, name: 'Oppfølging'},
		{ id: 9, name: 'Tilbud'},
		{ id: 12, name: 'Annet'},
	];

	private comment: string;
	private type: number;

	@Input() numOfComments: number;
	@Input() comments: Comment[];
	@Input() modelID: string;
	@Input() types: CommentType[];
	@Input() modelEntityID: number;
	@Input() displayForm: boolean = true;
	@Output('createdComment') createdComment = new EventEmitter<any>();

	constructor( private commentsService: CommentsService ) { }

	createComment(comment: string) {
		
		this.commentsService.createComment(this.modelID, this.modelEntityID, this.comment, this.type)
							.subscribe((response: any) => {
								console.log(response);
								this.createdComment.emit(response);
								this.comment = '';
								this.type = 0;
							})

	}

	// deleteComment(commentID: number) { // not prioritzed for alpha release
		
	// 	this.commentsService.deleteComment(commentID)
	// 						.subscribe((response: any) => {
	// 							console.log(response);
	// 							// this.createdComment.emit(response);
	// 						})

	// }

}



// WEBPACK FOOTER //
// ./src/app/comments/comments.component.ts